import React from 'react';
import { useCurrency } from '../contexts/CurrencyContext';

export const CurrencyDemo: React.FC = () => {
  const { currency, currencySymbol, currencyDisplay, formatCurrency, formatCurrencySimple } = useCurrency();

  const sampleAmount = 1234.56;

  return (
    <div style={{ padding: '20px', border: '1px solid #e2e8f0', borderRadius: '8px', margin: '20px 0' }}>
      <h3>Currency System Demo</h3>
      <p><strong>Current Settings:</strong></p>
      <ul>
        <li>Currency Code: {currency}</li>
        <li>Currency Symbol: {currencySymbol}</li>
        <li>Display Mode: {currencyDisplay}</li>
      </ul>
      
      <p><strong>Sample Amount ({sampleAmount}):</strong></p>
      <ul>
        <li>Formatted: {formatCurrency(sampleAmount)}</li>
        <li>Simple: {formatCurrencySimple(sampleAmount)}</li>
      </ul>
      
      <p><strong>Examples:</strong></p>
      <ul>
        <li>Invoice Total: {formatCurrency(2999.99)}</li>
        <li>Product Price: {formatCurrencySimple(149.99)}</li>
        <li>Tax Amount: {formatCurrency(299.99)}</li>
        <li>Discount: -{formatCurrencySimple(50.00)}</li>
      </ul>
    </div>
  );
};
